import type { RouteRecordRaw } from 'vue-router'

export const standaloneBillingRoutes: RouteRecordRaw[] = [
  {
    path: '/standalone-billing',
    component: () => import('@/views/standalone-billing/StandaloneBillingLayout.vue'),
    meta: {
      requiresAuth: false, // Initial check handles auth differently
      standalone: true,
      hideNavigation: true
    },
    children: [
      {
        path: '',
        name: 'standalone-billing-root',
        component: () => import('@/views/standalone-billing/StandaloneBillingRoot.vue'),
        meta: {
          title: 'Billing Portal'
        }
      },
      {
        path: 'login',
        name: 'standalone-billing-login',
        component: () => import('@/views/standalone-billing/StandaloneBillingLogin.vue'),
        meta: {
          title: 'Billing Portal Login',
          skipAuth: true
        }
      },
      {
        path: 'dashboard',
        name: 'standalone-billing-dashboard',
        component: () => import('@/views/standalone-billing/StandaloneBillingDashboard.vue'),
        meta: {
          title: 'Billing Dashboard',
          requiresStandaloneAuth: true
        }
      },
      {
        path: 'change-plan',
        name: 'standalone-billing-change-plan',
        component: () => import('@/views/standalone-billing/StandaloneBillingPlanChange.vue'),
        meta: {
          title: 'Change Subscription Plan',
          requiresStandaloneAuth: true
        }
      },
      {
        path: 'confirmation',
        name: 'standalone-billing-confirmation',
        component: () => import('@/views/standalone-billing/StandaloneBillingConfirmation.vue'),
        meta: {
          title: 'Change Confirmation',
          requiresStandaloneAuth: true
        }
      }
    ]
  }
]